var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LoginBaseModel } from './login-base-model';
var GoogleLoginModel = /** @class */ (function (_super) {
    __extends(GoogleLoginModel, _super);
    function GoogleLoginModel(idToken) {
        var _this = _super.call(this) || this;
        _this.token = idToken;
        return _this;
    }
    GoogleLoginModel.toJSON = function (value) {
        return {
            id_token: value.token,
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode
        };
    };
    return GoogleLoginModel;
}(LoginBaseModel));
export { GoogleLoginModel };
